module.exports = __webpack_public_path__ + "e15ba41bb87632c36c6ec302cc50c5cf.png";